import React from 'react';
import ReactDOM from 'react-dom';
import { AppContextProvider } from '../../../../../Services/AppContext';
import { loadDOMComponent } from '../../../../../helpers';
import { store } from '../../../../../store/store';
import { Provider } from 'react-redux';
import TherapistDetail from './TherapistDetail';

loadDOMComponent({
	selector: 'react-manager-therapist-detail',
	callback: ({ container, context }: any) => {
		const userId = container.getAttribute('userId');

		ReactDOM.render(
			<Provider store={store}>
				<AppContextProvider {...context}>
					<TherapistDetail userId={userId} />
				</AppContextProvider>
			</Provider>,
			container,
		);
	},
});
